import styled, { css } from 'styled-components';
import { COLOR_LIGHT_PURPLE, COLOR_WHITE } from '../../../../assets/styles/colors';

export const OptionsToggleSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const OptionSC = styled.div`
  background-color: ${COLOR_LIGHT_PURPLE};
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  padding: 6px 14px;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;

  .bold {
    font-weight: bold;
  }

  &:first-child {
    border-radius: 12px 0px 0px 12px;
  }

  &:last-child {
    border-radius: 0px 12px 12px 0px;
  }

  ${({ isActive }) => {
    if (isActive) {
      return css`
        color: ${COLOR_WHITE};
        border-radius: 10px !important;
        background-color: rgba(255, 255, 255, 0.2);
        padding-top: 10px;
        padding-bottom: 10px;
      `;
    }
  }};
`;
